var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cascader',_vm._g(_vm._b({ref:"cascader",attrs:{"dataMode":"standard","options":_vm.options}},'cascader',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }